import React from 'react';
import classnames from 'classnames';
import Tooltip, { TooltipConstants } from '@Components/Tooltip';
import PropTypes from 'prop-types';
import useAccessibleHoverTooltip from '@Components/HoverTooltip/useAccessibleHoverTooltip';
import HoverTooltip from '@Components/HoverTooltip';

import './SvgUseAsButton.scss';

export default function SvgUseAsButton(props) {
  // eslint-disable-next-line react/prop-types
  const { x, y, href, width, height, onClick, className, tabIndex, children, wrapperClassName, title, tooltipId, tooltip } = props;
  const keyHandler = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      onClick(e);
    }
  };

  const [tooltipRef, setTooltipRef] = React.useState(null);

  useAccessibleHoverTooltip(tooltipRef, true);

  React.useEffect(() => {
    Tooltip.rebuild();
    if (navigator.userAgent.indexOf('Chrome') !== -1) {
      document.documentElement.classList.add('chrome-only');
    }
  }, []);

  return (
    <>
      <g
        ref={(ref) => {
          setTooltipRef(ref);
        }}
        onClick={onClick}
        onKeyPress={keyHandler}
        className={classnames('svg-use-as-button--button', wrapperClassName)}>
        <rect fill="transparent" height={height} width={width} y={y} x={x} />
        {title && <title>{title}</title>}
        {href && <use className={className} href={href} height={height} width={width} y={y} x={x} />}
        {children}
      </g>
      <foreignObject
        width="20%"
        height="20%"
        className="svg-use-as-button--foreign-object"
        key={tooltipId || TooltipConstants.ids.TreeViewToolbar}
        y={y}
        x={x}
        onClick={onClick}
        onKeyPress={keyHandler}>
        <div xmlns="http://www.w3.org/1999/xhtml" className="svg-hover-tooltip-wrapper">
          <HoverTooltip tag="span" classnames={classnames(['els-btn-link els-btn-lg info-tooltip', className])} tooltip={tooltip}>
            <div tabIndex={tabIndex} />
          </HoverTooltip>
        </div>
      </foreignObject>
    </>
  );
}

SvgUseAsButton.propTypes = {
  tooltipId: PropTypes.string,
  tooltip: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};
